import e from "./highrise1528.mjs";
var a = e(Object, "create");
export {
  a as default
};
